import { render, staticRenderFns } from "./ProductCoversAdmin.vue?vue&type=template&id=631b361f&scoped=true&"
import script from "./ProductCoversAdmin.vue?vue&type=script&lang=js&"
export * from "./ProductCoversAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ProductCoversAdmin.vue?vue&type=style&index=0&id=631b361f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b361f",
  null
  
)

export default component.exports